export default __webpack_public_path__ + "static/media/daimler-tss.8d3ac986.svg";